import { Helmet } from 'react-helmet-async';
import { Layout } from '../components/layout';
import {
  Hero,
  Services,
  HowItWorks,
  Impact,
  Industries,
  WhyEcoEnviro,
  Team,
  Presence,
  Clients,
  CTA,
} from '../components/home';

const SITE_URL = 'https://www.theecoenviro.com';

export function Home() {
  return (
    <Layout>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          Eco Enviro Circular Solutions | Waste Management & Recycling Services in India
        </title>
        <meta
          name="title"
          content="Eco Enviro Circular Solutions | Waste Management & Recycling Services in India"
        />
        <meta
          name="description"
          content="Eco Enviro Circular Solutions - India's trusted waste management company. We offer plastic recycling, EPR services, e-waste management, factory waste solutions, and scrap trading. 100,000+ MT waste diverted across 7 states. Contact us for sustainable waste solutions."
        />
        <meta
          name="keywords"
          content="Eco Enviro, Eco Enviro Circular Solutions, theecoenviro, waste management India, plastic recycling Jharkhand, EPR services India, e-waste recycling, factory waste management, scrap trading Bihar, circular economy India, RDF production, corporate waste management, Ranchi recycling, Ranchi waste management, sustainable waste solutions"
        />
        <meta name="author" content="Eco Enviro Circular Solutions" />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        {/* Canonical URL */}
        <link rel="canonical" href={`${SITE_URL}/`} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta
          property="og:title"
          content="Eco Enviro Circular Solutions | Waste Management & Recycling Services in India"
        />
        <meta
          property="og:description"
          content="India's trusted waste management company. Plastic recycling, EPR services, e-waste management, factory waste solutions. 100,000+ MT waste diverted across 7 states."
        />
        <meta property="og:site_name" content="Eco Enviro Circular Solutions" />
        <meta property="og:image" content={`${SITE_URL}/images/og-image.png`} />
        <meta property="og:image:secure_url" content={`${SITE_URL}/images/og-image.png`} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Eco Enviro Circular Solutions - Closing the Loop. Creating Impact. Comprehensive Waste Management Solutions in India"
        />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@theecoenviro" />
        <meta name="twitter:creator" content="@theecoenviro" />
        <meta name="twitter:url" content={`${SITE_URL}/`} />
        <meta
          name="twitter:title"
          content="Eco Enviro Circular Solutions | Waste Management & Recycling Services in India"
        />
        <meta
          name="twitter:description"
          content="India's trusted waste management company. Plastic recycling, EPR services, e-waste management. 100,000+ MT waste diverted across 7 states."
        />
        <meta name="twitter:image" content={`${SITE_URL}/images/og-image.png`} />
        <meta
          name="twitter:image:alt"
          content="Eco Enviro Circular Solutions - Waste Management Services"
        />

        {/* Geo Tags for Local SEO */}
        <meta name="geo.region" content="IN-JH" />
        <meta name="geo.placename" content="Ranchi, Jharkhand" />
        <meta name="geo.position" content="23.3441;85.3096" />
        <meta name="ICBM" content="23.3441, 85.3096" />
      </Helmet>

      <Hero />
      <Services />
      <HowItWorks />
      <Impact />
      <Industries />
      <WhyEcoEnviro />
      <Team />
      <Presence />
      <Clients />
      <CTA />
    </Layout>
  );
}
